export const ApprovalTemplateRules = {
  NON_SEQUENTIAL: 'NON_SEQUENTIAL',
  ANY_CAN_APPROVE: 'ANY_CAN_APPROVE',
  SEQUENTIAL: 'SEQUENTIAL'
};
export const MAX_APPROVAL_TEMPLATE_DUE_DATE_OFFSET_DAYS = 365;